/* eslint-disable */
import axios from 'axios'
import { encode64 } from '@/js/utils/base64'
import { sanitize } from '@/js/utils/sanitize'
import { randomBaseUrl } from '@/js/utils/randomBaseUrl'
import i18n from '@/plugins/i18n/i18n'

export const askQuestion = async params => new Promise (async (resolve, reject) => {
  let attachs = null
  // console.log('in')

  if (Array.isArray(params.attach) && params.attach.length > 0) {
    attachs = []

    for (var i = 0, len = params.attach.length; i < len; i++) {
      await encode64(params.attach[i])
        .then(response => {
          // attachs[`attach${i}`] = encodeURIComponent(response)
          attachs.push(encodeURIComponent(response))
          if (i === (len - 1)) {
            constructResponse(params, attachs)
              .then(response => resolve(response))
              .catch(error => reject(error))
          }
        })
        .catch(() => {return})
    }
  } else {
    constructResponse(params)
      .then(response => resolve(response))
      .catch(error => resolve(error))
  }
})

const constructResponse = (params, attachs) => new Promise((resolve, reject) => {

  const currentLanguage = i18n.locale &&
                          i18n.locale !== null && i18n.locale !== 'null' &&
                          i18n.locale !== undefined && i18n.locale !== 'undefined' ? i18n.locale : 'en'

  let keywords = params.keywords ? sanitize(params.keywords) : null
  let lang = params.lang && params.lang !== null && params.lang !== 'null' &&
             params.lang !== undefined && params.lang !== 'undefined' ? sanitize(params.lang) : 'en'
  let page = params.page ? sanitize(params.page) : null
  let question = params.question ? sanitize(params.question) : null
  let context = params.context ? sanitize(params.context) : null
  let key = sanitize(params.key)

  keywords = keywords ? encodeURIComponent(keywords) : null
  lang = lang ? encodeURIComponent(lang) : 'en'
  page = page ? encodeURIComponent(page) : null
  question = question ? encodeURIComponent(question) : null
  context = context ? encodeURIComponent(context) : null
  key = encodeURIComponent(key)

  let uri = '?options=json'
  uri = `${uri}&valid=${key}`

  if (attachs && attachs !== null && attachs !== 'null'
      && attachs !== undefined && attachs !== 'undefined') {
    if (Array.isArray(attachs) && attachs.length > 0) {
      for (var i = 0, len = attachs.length; i < len; i++) {
        if (i === 0) { uri = `${uri}&attach=${attachs[i]}` }
        else { uri = `${uri}&attach${i+1}=${attachs[i]}` }
      }
    }
    else if (Array.isArray(attachs)) { uri = `${uri}&attach=${attachs[0]}` }
    else { uri = `${uri}&attach=${attachs}` }
  }

  uri = keywords &&
        keywords !== null &&
        keywords !== 'null' ? `${uri}&keyword=${keywords}` : `${uri}&keyword=all`
  uri = lang ? `${uri}&lang=${lang}` : `${uri}&lang=en`
  uri = page &&
        page !== null &&
        page !== 'null' ? `${uri}&page=${page}` : `${uri}&page=all`
  uri = question ? `${uri}&question=${question}` : uri
  uri = context &&
        context !== null &&
        context !== 'null' ? `${uri}&context=${context}` : uri

  let alert = false
  let alertType = 'error'
  let alertMessage = i18n.messages[currentLanguage]['basic-message']['error-message']

  axios({
    method: 'post',
    url: randomBaseUrl(0, 3) + process.env.VUE_APP_POST_QUESTIONS_ENDPOINT,
    data: uri
  })
    .then(response => {
      const status = response.data.status
      const message = response.data.message
      if (status === 'error') {
        alert = true
        switch (message) {
          case 'Please ask a question':
            alertType = 'error'
            alertMessage = i18n.messages[currentLanguage]['question-alert']['ask']
            break

          case 'Cannot decode attachment, sorry':
            alertType = 'error'
            alertMessage = i18n.messages[currentLanguage]['question-alert']['cannot-decode-attch']
            break

          default:
            alertType = 'error'
            alertMessage = i18n.messages[currentLanguage]['question-alert']['cannot-decode-attch']
            break
        }
      }
      else if (status === 'ok') {
        alert = true
        alertType = 'success'
        alertMessage = i18n.messages[currentLanguage]['question-alert']['success']
      } else { alert = true }
      resolve({
        status: status,
        alert: alert,
        alertType: alertType,
        alertMessage: alertMessage
      })
    })
    .catch(error => { reject(error) })
})
